import { z } from 'zod';

import { objectIdRef, ObjectIdSchema } from '../common.js';
import { DateTimeSchema } from '../dates.js';
import { DateTime } from 'luxon';

export const OneTimeCodeStatus = z.enum(['new', 'used', 'expired']);
export type OneTimeCodeStatus = z.infer<typeof OneTimeCodeStatus>;

export const IOneTimeCode = z.object({
  _id: ObjectIdSchema,
  account: objectIdRef('Account'),
  integration: objectIdRef('Integration'),
  type: z.enum(['emailOtp', 'passwordReset']).default('emailOtp'),
  status: OneTimeCodeStatus.default('new'),
  username: z.string(),
  recipient: z.email(),
  rawData: z.looseObject({}).nullish(),
  code: z.string(),
  // Set with .prefault() so zodToMongoose will register the getter correctly
  expiresAt: DateTimeSchema.prefault(() => DateTime.now().plus({ hours: 1 })),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IOneTimeCode = z.infer<typeof IOneTimeCode>;
